<div class="container">
  <img src="../../../../../assets/icons/security-user.svg" class="logo" />
  <div class="header">
    <p class="title-text">Activa tu perfil de inversionista</p>
    <div class="subtitles">
      <p class="subtitle-text">
        Queremos conocerte mejor para que accedas a las oportunidades en Factoring y Confirming.
      </p>
      <p class="subtitle-text-2" *ngIf="isJuridico">
        Ten a la mano la Copia Literal no mayor a 30 días y Reporte Tributario Válido.
      </p>
    </div>
  </div>

  <div class="footer">
    <div class="info">
      <lib-ui-info-text
        showIcon="true"
        iconName="info"
        body="Necesitamos validar tu información para prevenir riesgos de lavado de
        activos (LAFT) y garantizar que inviertas con confianza."
        showTitle="false"
      ></lib-ui-info-text>
    </div>

    <div class="button-actions">
      <fs-ui-button
        [action]="'submit'"
        (click)="dialogRefModal.close('open_laft_form')"
        [label]="'Completar mi perfil'"
      ></fs-ui-button>
      <p class="advise">Toma pocos minutos y podrás acceder a las oportunidades.</p>
      <div class="text-button">
        <lib-ui-button
          variant="text"
          [fullWidth]="false"
          size="m"
          (click)="dialogRefModal.close('closed')"
          [label]="'Lo haré después'"
        ></lib-ui-button>
      </div>
    </div>
  </div>
</div>
